var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useEffect } from "react";
import useSWR from "swr";
import { useTranslation } from "react-i18next";
import { useFilters } from "../../Hooks/useFilters";
import { API_KEY, ENDPOINT, SWRThirdParams, fetcher } from "../../api";
import { Alert } from "../Alert";
import { Loading } from "../Loading";
function Competition(_a) {
    var _b, _c;
    var competition = _a.competition, competitionDefault = _a.competitionDefault, isSidebarWidget = _a.isSidebarWidget;
    var t = useTranslation().t;
    var _d = useFilters(), selectedCompetition = _d.selectedCompetition, handleSetSelectedCompetition = _d.handleSetSelectedCompetition, handleSetSelectedCompetitionObject = _d.handleSetSelectedCompetitionObject;
    var requestParam = [ENDPOINT.COMPETITIONS, API_KEY];
    var _e = useSWR(requestParam, function (_a) {
        var url = _a[0], apiKey = _a[1];
        return fetcher(url, apiKey);
    }, SWRThirdParams), response = _e.data, error = _e.error, isLoading = _e.isLoading;
    function changeCompetition(id, index) {
        handleSetSelectedCompetition(id);
    }
    useEffect(function () {
        var _a, _b, _c, _d;
        if ((competition || competitionDefault) && ((_a = response === null || response === void 0 ? void 0 : response.data[0]) === null || _a === void 0 ? void 0 : _a.id)) {
            var foundedCompetition = (_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.umbracoContentID === (competition || competitionDefault); });
            if (foundedCompetition) {
                handleSetSelectedCompetition(foundedCompetition === null || foundedCompetition === void 0 ? void 0 : foundedCompetition.id);
                handleSetSelectedCompetitionObject(foundedCompetition);
            }
        }
        else {
            if ((_c = response === null || response === void 0 ? void 0 : response.data[0]) === null || _c === void 0 ? void 0 : _c.id) {
                handleSetSelectedCompetition((_d = response === null || response === void 0 ? void 0 : response.data[0]) === null || _d === void 0 ? void 0 : _d.id);
            }
        }
    }, [handleSetSelectedCompetition, response, competition, competitionDefault, handleSetSelectedCompetitionObject]);
    if (competition) {
        return null;
    }
    if (isLoading) {
        return _jsx(Loading, {});
    }
    if (error) {
        return _jsx("p", __assign({ className: "twc-w-full twc-text-center" }, { children: t('serverError') }));
    }
    return ((_b = response === null || response === void 0 ? void 0 : response.data) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (_jsx("div", __assign({ className: "twc-flex twc-justify-center twc-py-2 ".concat(isSidebarWidget ? " twc-px-2 " : " twc-px-4 ") }, { children: _jsx("ul", __assign({ className: "competitions twc-flex twc-flex-row twc-overflow-x-scroll twc-gap-[40px]" }, { children: (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.map(function (item, index) {
                var _a;
                return (_jsx("li", { children: _jsx("picture", __assign({ onClick: function () { return changeCompetition(item.id, index); }, className: "twc-flex twc-justify-center twc-pb-[15px] twc-cursor-pointer twc-min-w-max" }, { children: _jsx("img", { className: "twc-h-[30px] twc-min-w-max twc-bg-center ".concat(selectedCompetition !== item.id ? "twc-grayscale" : ""), src: item.image, title: item.name, alt: (_a = t("image")) !== null && _a !== void 0 ? _a : "image" }) })) }, item.id));
            }) })) }))) : (_jsx(Alert, {}));
}
export var MemoizedCompetition = memo(Competition);
